module.exports = __webpack_public_path__ + "img/reinforcing-bars-card.c0495a91.jpg";